// extracted by mini-css-extract-plugin
export var label = "_j6-2";
export var slideContainer = "_j6-0";
export var slider = "_j6-1";